/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCreateServiceKeyRequest } from '../models/TCreateServiceKeyRequest';
import type { TCreateServiceKeyResponse } from '../models/TCreateServiceKeyResponse';
import type { TListServiceKeysResponse } from '../models/TListServiceKeysResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceKeysService {
    /**
     * Create a new service key.
     * Returns the raw key once; it cannot be retrieved again.
     * @param requestBody
     * @returns TCreateServiceKeyResponse TCreateServiceKeyResponse
     * @throws ApiError
     */
    public static createServiceKey(
        requestBody: TCreateServiceKeyRequest,
    ): CancelablePromise<TCreateServiceKeyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/service-keys',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List all service keys.
     * Never returns the raw key.
     * @returns TListServiceKeysResponse TListServiceKeysResponse
     * @throws ApiError
     */
    public static listServiceKeys(): CancelablePromise<TListServiceKeysResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service-keys',
        });
    }
    /**
     * Revoke a service key.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static revokeServiceKey(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/service-keys/{id}',
            path: {
                'id': id,
            },
        });
    }
}
